<template>
    <div>
        <ul class="filter">
            <li class="filter-item">
                <button class="filter-button btn" :class="{ 'active': !value.year }" role="button" @click="handleYearChanged(null)">
                    prochainement
                </button>
            </li>

            <template v-for="year in criterias.years">
                <li class="filter-item">
                    <button class="filter-button btn" :class="{ 'active': value.year === year }" @click="handleYearChanged(year)">
                        {{ year }}
                    </button>
                </li>
            </template>
        </ul>
<!--        <hr>-->
<!--        <div>-->
<!--            <div>-->
<!--                <template v-for="company in companies">-->
<!--                    {{ company.name }},-->
<!--                </template>-->
<!--            </div>-->
<!--            <router-link :to="filterRoute('companies')" replace v-slot="{ href, navigate }">-->
<!--                <a :href="href" @click="navigate">-->
<!--                    filtrer par équipe artistique-->
<!--                </a>-->
<!--            </router-link>-->
<!--        </div>-->
        <hr>
        <div class="row mb-n3">
            <div class="col-md-6 col-lg-4 mb-3">
                <label for="artisticFields">Champs artistiques</label>
                <ArtisticFieldSelect
                    id="artisticFields"
                    :value="value.artisticFields"
                    :fields="criterias.artisticFields"
                    @change="handleArtisticFieldChanged"
                />
            </div>
            <div class="col-md-6 col-lg-4 mb-3">
                <label for="departments">Départements</label>
                <DepartmentSelect
                    id="departments"
                    :value="value.departments"
                    @change="handleDepartmentChanged"
                />
            </div>
            <div class="col-md-6 col-lg-4 mb-3">
                <label for="audience">Type</label>
                <select id="audience" class="custom-select" :value="value.audience" @change="handleAudienceChanged">
                    <option value="">tous types</option>
                    <template v-for="(label, value) in criterias.audience">
                        <option :value="value">{{ label }}</option>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import ArtisticFieldSelect from "./criterias/ArtisticFieldSelect";
import DepartmentSelect from "../search/criterias/geo/DepartmentSelect";

export default {
        components: {
            ArtisticFieldSelect,
            DepartmentSelect,
        },
        props: {
            value: Object,
            criterias: Object,
            companies: Array,
        },
        methods: {
            filterRoute(name) {
                return {
                    name,
                    query: this.$route.query,
                }
            },
            handleYearChanged(year) {
                this.$emit('input', {
                    ...this.value,
                    year,
                });
            },
            handleArtisticFieldChanged(artisticFields) {
                this.$emit('input', {
                    ...this.value,
                    artisticFields,
                });
            },
            handleDepartmentChanged(departments) {
                this.$emit('input', {
                    ...this.value,
                    departments,
                });
            },
            handleAudienceChanged(e) {
                this.$emit('input', {
                    ...this.value,
                    audience: e.target.value,
                });
            },
        },
    }
</script>